import React from 'react';
import {
    Edit,
    SimpleForm,
    TextField,
    SelectInput,
    Toolbar,
} from 'react-admin';
import SaveButton from '../common/SaveButton';
import CancelButton from '../common/CancelButton';

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
        <CancelButton />
    </Toolbar>
);

const UserEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<EditToolbar />} submitOnEnter={false}>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="email" />
            <SelectInput source="permission" choices={[
                { id: 0, name: 'resources.users.enums.permission.normal' },
                { id: 1, name: 'resources.users.enums.permission.operationManager' },
                { id: 2, name: 'resources.users.enums.permission.accountManager' },
                { id: 3, name: 'resources.users.enums.permission.admin' }
            ]} />
        </SimpleForm>
    </Edit>
);

export default UserEdit;